import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

// @ts-ignore
export const vuetify = new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
});

export default vuetify;
